// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-blocks/accolades-list-blocks.component.scss
// module id = 520
// module chunks = 0